import React from 'react';
import Nexora from '../../assets/nexora.png'
function dfoot() {
    return (
        <footer >
  <div class="container">
    <div class="row g-4">
      <div class="col-lg-5">
        <div class="footer-logo mb-4">Nexora Systems</div>
     <img class="w-100" style={{maxWidth:'250px'}} src={Nexora}/>
      </div>
      <div class="col-lg-3 offset-lg-1">
                        <p style={{ fontSize:'.65rem', letterSpacing:'.16rem',textTransform:'uppercase',color:'white'}}>Navigation</p>
        <ul class="footer-links flex-column gap-3" style={{paddingLeft:'0rem', color:'white'}}>
          <li ><a class="footer-nav" href="#intro"  >Company Overview</a></li>
          <li><a class="footer-nav" href="#reasons" >Why Invest</a></li>
          <li><a class="footer-nav" href="#business" >Business Summary</a></li>
          <li><a class="footer-nav" href="#market" >Market Analysis</a></li>
          <li><a class="footer-nav" href="#terms" >Offering Terms</a></li>
          <li><a class="footer-nav"href="#team" >Management Team</a></li>
        </ul>
      </div>
      <div class="col-lg-3">
        <p style={{fontSize:'.65rem', letterSpacing:'.16rem', textTransform:'uppercase', color:'white', marginBottom:'20px'}}>Contact</p>
        <p style={{fontSize:'.82rem', lineHeight:'1.8'}} class="footer-contact">
          Nexora Systems<br/>
          1501 Broadway, Suite 1700<br/>
          New York, NY 10036<br/><br/>
          investor@nexorasystems.com<br/>
          +1 (212) 534-5423 
        </p>
      </div>
    </div>
    <div class="footer-copy text-center ">
  <p style={{color:'white'}}> Regulation D 506(c) Mandated Legend
<br/>

Any historical performance data represents past performance. Past performance does not guarantee future results; Current performance may be different than the performance data presented; The Company is not required by law to follow any standard methodology when calculating and representing performance data; The performance of the Company may not be directly comparable to the performance of other private or registered funds or companies; The securities are being offered in reliance on an exemption from the registration requirements, and therefore are not required to comply with certain specific disclosure requirements; The Securities and Exchange Commission has not passed upon the merits of or approved the securities, the terms of the offering, or the accuracy of the materials.</p>
    </div>
  </div>
</footer>
    )
}

export default dfoot